<template>
    <v-data-table v-bind="{ headers, items, loading }" disable-filtering disable-sort class="v-sheet--outlined fill-height">
        <template #top>
            <v-card-subtitle>자재연결 목록</v-card-subtitle>
            <v-divider />
        </template>

        <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" :title="header.withTitle ? header.formatter.bind(item)(value, item) : undefined" v-html="header.formatter.bind(item)(value, item)" /> </template>

        <template #[`item.code`]="{ item }">
            <v-list-item dense target="_blank" :href="item.href">
                <v-list-item-avatar color="content">
                    <v-img :src="item.photo">
                        <template #placeholder> <v-icon>mdi-chip</v-icon> </template>
                    </v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title :title="item.code"> {{ item.code }} </v-list-item-title>
                    <v-list-item-subtitle :title="item.vendorItemCode"> {{ item.vendorItemCode }} </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </template>

        <template #[`item.shows`]="{ item }">
            <v-switch v-model="item.shows" class="d-inline-block ml-1 mr-n3" v-bind="attrs_switch" @change="(shows) => update({ _id: item._id, shows })" />
        </template>
        <template #[`item.isActive`]="{ item }">
            <v-switch v-model="item.isActive" class="d-inline-block ml-1 mr-n3" v-bind="attrs_switch" @change="(isActive) => update({ _id: item._id, isActive })" />
        </template>
        <template #[`item.actions`]="{ item }">
            <manufacturing-material-link-update-btn v-bind="{ loading, material, link: item }" @setLoading="(bool) => (loading = bool)" @init="$emit('init')" small text color="primary">
                정보반영
            </manufacturing-material-link-update-btn>
        </template>
    </v-data-table>
</template>

<script>
import api from "@/api";
import { attrs_switch, initDataTableHeaders, initManufacturingMaterial, MANUFACTURING_VENDOR_CODES, MANUFACTURING_VENDOR_CURRENCIES } from "@/assets/variables";

import ManufacturingMaterialLinkUpdateBtn from "../action/manufacturing-material-link-update-btn.vue";

export default {
    components: {
        ManufacturingMaterialLinkUpdateBtn,
    },
    props: {
        material: { type: Object, default: initManufacturingMaterial },
    },

    data: () => ({
        loading: false,

        attrs_switch,
    }),
    computed: {
        headers() {
            return initDataTableHeaders([
                { text: "벤더", value: "vendorCode", formatter: (value) => MANUFACTURING_VENDOR_CODES[value]?.text, width: +80 },
                { text: "자재", value: "code", cellClass: "text-truncate max-width-0 pa-0", withTitle: true },
                { text: "단위", value: "count", width: +80, formatter: (value) => value?.format?.(), align: "end" },
                {
                    text: "가격",
                    value: "price",
                    width: +80,
                    formatter: (value, item) => {
                        let currency = MANUFACTURING_VENDOR_CURRENCIES[item?.vendor?.currency];
                        let isUSD = currency.value == MANUFACTURING_VENDOR_CURRENCIES.USD.value;

                        return `${currency?.prefix || ""}${value?.format?.(isUSD ? 2 : 0)}`;
                    },
                    align: "end",
                },
                { text: "재고", value: "stock", width: +80, formatter: (value) => value?.format?.(), align: "end" },
                { text: "표시여부", value: "shows", width: +80 },
                { text: "갱신여부", value: "isActive", width: +80 },
                { text: "", value: "actions", width: +80, cellClass: "pa-0" },
            ]);
        },
        items() {
            return this.material.links;
        },
    },
    methods: {
        async update(item) {
            if (this.loading) return;
            else this.loading = true;
            try {
                const { link } = await api.console.manufacturing.materials.links.put({ ...item, _material: this.material._id });
                this.loading = false;
                this.$emit("updateLinkItem", link);
            } finally {
                if (this.loading) this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .line-height-1-5 {
        line-height: 1.5;
    }
    .max-width-0 {
        max-width: 0;
    }
    .word-break-keep-all {
        word-break: keep-all;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    .v-small-dialog__activator {
        height: 100%;
    }
    .v-small-dialog__activator__content {
        width: 100%;
    }

    th:first-of-type:not(:last-of-type),
    td:first-of-type:not(:last-of-type) {
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }

    .v-data-table__expanded__content {
        box-shadow: none !important;
    }
    .vertical-align-top {
        vertical-align: top !important;
    }
}
</style>
